import { render, staticRenderFns } from "./menuBar.vue?vue&type=template&id=b21447e8&scoped=true&"
import script from "./menuBar.vue?vue&type=script&lang=ts&"
export * from "./menuBar.vue?vue&type=script&lang=ts&"
import style0 from "./menuBar.vue?vue&type=style&index=0&id=b21447e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21447e8",
  null
  
)

export default component.exports